import { ComponentFactoryResolver, ComponentRef, Type, ViewContainerRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { loadCrmProposalHistoryWidgetComponent } from './lazy-load-crm-proposal-history-widget';

let cachedWidgetComponent: Type<any> | null = null;

export interface CrmProposalHistoryWidgetMountResult {
  ref: ComponentRef<any>;
  openHistorySub: Subscription | null;
}

export async function mountCrmProposalHistoryWidget(params: {
  host: ViewContainerRef;
  componentFactoryResolver: ComponentFactoryResolver;
  accountId?: string;
  onOpenHistory: () => void;
}): Promise<CrmProposalHistoryWidgetMountResult> {
  if (!cachedWidgetComponent) {
    cachedWidgetComponent = await loadCrmProposalHistoryWidgetComponent();
  }

  const componentFactory = params.componentFactoryResolver.resolveComponentFactory(cachedWidgetComponent);
  params.host.clear();
  const ref = params.host.createComponent(componentFactory);
  ref.instance.accountId = params.accountId;

  const openHistorySub = ref.instance?.openHistory?.subscribe
    ? ref.instance.openHistory.subscribe(() => params.onOpenHistory())
    : null;

  return { ref, openHistorySub };
}
